/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PresentingConcernsResponseDto,
  PresentingConcernsUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PresentingConcernsResponseDtoFromJSON,
    PresentingConcernsResponseDtoToJSON,
    PresentingConcernsUpsertRequestDtoFromJSON,
    PresentingConcernsUpsertRequestDtoToJSON,
} from '../models/index';

export interface GetPresentingConcernsByPatientIdRequest {
    patientId: string;
}

export interface UpsertPresentingConcernsRequest {
    presentingConcernsUpsertRequestDto: PresentingConcernsUpsertRequestDto;
}

export interface UpsertPresentingConcernsByPatientIdRequest {
    patientId: string;
    presentingConcernsUpsertRequestDto: PresentingConcernsUpsertRequestDto;
}

/**
 * 
 */
export class PatientPresentingConcernsApi extends runtime.BaseAPI {

    /**
     * Retrieve presenting concerns including primary health concerns, when first noticed, and treatments tried
     * Get patient\'s presenting concerns
     */
    async getPresentingConcernsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresentingConcernsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/presenting-concerns`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresentingConcernsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve presenting concerns including primary health concerns, when first noticed, and treatments tried
     * Get patient\'s presenting concerns
     */
    async getPresentingConcerns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresentingConcernsResponseDto> {
        const response = await this.getPresentingConcernsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s presenting concerns by patient ID
     */
    async getPresentingConcernsByPatientIdRaw(requestParameters: GetPresentingConcernsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresentingConcernsResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPresentingConcernsByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/presenting-concerns/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresentingConcernsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s presenting concerns by patient ID
     */
    async getPresentingConcernsByPatientId(requestParameters: GetPresentingConcernsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresentingConcernsResponseDto> {
        const response = await this.getPresentingConcernsByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update presenting concerns with primary health concerns (required), when first noticed, and treatments tried
     * Update patient\'s presenting concerns
     */
    async upsertPresentingConcernsRaw(requestParameters: UpsertPresentingConcernsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresentingConcernsResponseDto>> {
        if (requestParameters['presentingConcernsUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'presentingConcernsUpsertRequestDto',
                'Required parameter "presentingConcernsUpsertRequestDto" was null or undefined when calling upsertPresentingConcerns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/presenting-concerns`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PresentingConcernsUpsertRequestDtoToJSON(requestParameters['presentingConcernsUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresentingConcernsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update presenting concerns with primary health concerns (required), when first noticed, and treatments tried
     * Update patient\'s presenting concerns
     */
    async upsertPresentingConcerns(requestParameters: UpsertPresentingConcernsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresentingConcernsResponseDto> {
        const response = await this.upsertPresentingConcernsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create patient\'s presenting concerns by patient ID
     */
    async upsertPresentingConcernsByPatientIdRaw(requestParameters: UpsertPresentingConcernsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresentingConcernsResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertPresentingConcernsByPatientId().'
            );
        }

        if (requestParameters['presentingConcernsUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'presentingConcernsUpsertRequestDto',
                'Required parameter "presentingConcernsUpsertRequestDto" was null or undefined when calling upsertPresentingConcernsByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/presenting-concerns/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PresentingConcernsUpsertRequestDtoToJSON(requestParameters['presentingConcernsUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresentingConcernsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create patient\'s presenting concerns by patient ID
     */
    async upsertPresentingConcernsByPatientId(requestParameters: UpsertPresentingConcernsByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresentingConcernsResponseDto> {
        const response = await this.upsertPresentingConcernsByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
